import {
    apiRequest,
    pemutihanAbsenCreate,
    employeeList
} from "../../../../../services/adapters/kepegawaian/pemutihanAbsenService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pemutihanAbsenCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
}

export default CreateRepository